import configdata from "../../config.json";
import { operatorSliceAction } from "./OperatorSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllOperatorItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/operators`);
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(operatorSliceAction.getAllOperator(res.data.operator));
  };
};
export const createOperatorItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/operators/store`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          operatorSliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      operatorSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(operatorSliceAction.setInitialData());
    dispatch(getAllOperatorItems());
  };
};
export const getDataForEdit = (id, factoryList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/operators/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.operator[0] };

    const factory = factoryList.find((item) => {
      return item.value === data.factory_id;
    });

    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };

    data.factory = {
      value: factory.value,
      label: factory.label,
      type: factory.type,
    };
    dispatch(operatorSliceAction.getOperatorDataEdit(data));
  };
};

export const updateOperatorItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/operators/update/${data.id}`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          operatorSliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      operatorSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(operatorSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllOperatorItems());
  };
};

export const deleteOperatorItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/operators/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
